export default function SvgCrossRounded(props) {
    return (
        <svg {...props} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="9" cy="9" r="8.5" stroke="currentColor"/>
            <path d="M12 6.36331L6.36268 12.0006M12 6.36331L6.36268 12.0006" stroke="currentColor"/>
            <path d="M12 12.0006L6.36268 6.36332M12 12.0006L6.36268 6.36332" stroke="currentColor"/>
        </svg>

    )
}